// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightBox_wrapper__UXMMc"};